import React, { useState } from "react";
import "../styles/FeesChargesPage.css";

export default function FeesChargesPage() {

const [search,setSearch] = useState("");

const scrollTo = (id)=>{
const el=document.getElementById(id);
if(el){
el.scrollIntoView({behavior:"smooth"});
}
};

const handleSearch=(e)=>{
const value=e.target.value.toLowerCase();
setSearch(value);

if(value.includes("atm")) scrollTo("A2");
if(value.includes("saving")) scrollTo("A");
if(value.includes("current")) scrollTo("G");
if(value.includes("loan")) scrollTo("T");
if(value.includes("neft")) scrollTo("O");
if(value.includes("locker")) scrollTo("A6");
};

return (

<div className="fees-page">


{/* HERO */}

<section className="fees-hero">

<h1>Fees & Charges</h1>

<p>
Transparent service charges for banking services.
</p>

</section>



{/* SEARCH + TABS */}

<section className="fees-controls">

<input
type="text"
placeholder="Search charges (e.g. cheque, NEFT, ATM...)"
value={search}
onChange={handleSearch}
/>

<div className="fees-tabs">

<button onClick={()=>scrollTo("A")}>Savings A/c</button>
<button onClick={()=>scrollTo("G")}>Current A/c</button>
<button onClick={()=>scrollTo("T")}>Loans</button>
<button onClick={()=>scrollTo("O")}>Digital</button>
<button onClick={()=>scrollTo("A8")}>Other</button>

</div>

</section>



{/* SUMMARY CARDS */}

<section className="fees-summary">

<div className="fees-summary-card">
<h3>₹500</h3>
<p>SB Min Balance</p>
</div>

<div className="fees-summary-card">
<h3>₹3,000</h3>
<p>CA Min Balance</p>
</div>

<div className="fees-summary-card">
<h3>₹10</h3>
<p>NEFT ≤ ₹50K</p>
</div>

<div className="fees-summary-card">
<h3>3 Free</h3>
<p>ATM Transactions</p>
</div>

<div className="fees-summary-card">
<h3>1%</h3>
<p>Loan Processing</p>
</div>

</section>



{/* ===== SAVINGS ACCOUNT ===== */}

<Section id="A" title="Savings Account – Minimum Balance Charges"
rows={[
["Without cheque book (Min ₹500) Shortfall up to ₹500","₹30 + GST"],
["Shortfall above ₹500","₹40 + GST"],
["With cheque book (Min ₹1000)","Same charges as above"]
]}

/>

<Section id="B" title="Savings Account – Closure Charges"
rows={[
["Closed within 1 year","₹150 + GST"],
["Closed after 1 year","₹100 + GST"],
["Unused cheque leaves","₹10/leaf + GST"]
]}
/>

<Section id="C" title="Cheque Return Charges – Savings Account"
rows={[
["Inward Clearing return up to ₹1L","₹300 + GST"],
["Inward Clearing return ₹1L–10L","₹750 + GST"],
["Inward Clearing return above ₹10L","₹1500 + GST"],
["Outward Clearing return up to ₹1L","₹300 + GST"],
["Outward Clearing return ₹1L–10L","₹500 + GST"],
["Outward Clearing return above ₹10L","₹1000 + GST"]
]}
/>

<Section id="D" title="Stop Payment Charges – Savings Account"
rows={[
["Stop payment cheque","₹100/cheque (Max ₹500) + GST"],
["Cancellation of stop payment","₹100/cheque (Max ₹500) + GST"]
]}
/>

<Section id="E" title="Cheque Book Charges – Savings Account"
rows={[
["First cheque book (15 cheques)","NIL"],
["Second cheque book onwards","₹6.50/leaf + GST"],
["Courier charges if returned undelivered","Actual courier charges + GST"]
]}
/>

<Section id="F" title="Duplicate Passbook – Savings Account"
rows={[
["With present balance only","₹100 + GST"],
["With previous entries","₹100 + ₹10/page + GST"],
["Computer statement","₹50/page + GST"]
]}
/>



{/* ===== CURRENT ACCOUNT ===== */}

<Section id="G" title="Current Account – Minimum Balance"
rows={[
["Min Balance ₹3000","₹250 + GST"]
]}
/>

<Section id="H" title="Cheque Book Charges – Current Account"
rows={[
["All cheque books","₹6.50/leaf + GST"]
]}
/>

<Section id="I" title="Current Account Statement Charges"
rows={[
["1st printing","NIL"],
["Duplicate printing","₹50/page"],
["Folio charges","₹200 + GST"]
]}
/>

<Section id="J" title="Cheque Return Charges – Current Account"
rows={[
["Inward return up to ₹1L","₹300 + GST"],
["Inward return ₹1L–10L","₹750 + GST"],
["Inward return above ₹10L","₹1500 + GST"],
["Outward return up to ₹1L","₹300 + GST"],
["Outward return ₹1L–10L","₹500 + GST"],
["Outward return above ₹10L","₹1000 + GST"]
]}
/>

<Section id="K" title="Stop Payment Charges – Current Account"
rows={[
["Stop payment cheque","₹100/cheque + GST"],
["Cancellation of stop payment","₹100/cheque + GST"]
]}
/>

<Section id="L" title="Account Closure Charges – Current Account"
rows={[
["Closed within 1 year","₹250 + GST"],
["Closed after 1 year","₹150 + GST"]
]}
/>

<Section id="M" title="Cash Handling Charges – Current Account"
rows={[
["Up to ₹2L","NIL"],
["Every additional ₹1L","₹100 + GST"]
]}
/>



{/* ===== OTHER SERVICES ===== */}

<Section id="N" title="Fixed Deposit"
rows={[
["Duplicate FD receipt","₹100 + GST"]
]}
/>

<Section id="O" title="NEFT / RTGS Charges"
rows={[
["NEFT up to ₹50,000","₹10 + GST"],
["NEFT up to ₹2,00,000","₹20 + GST"],
["RTGS above ₹2,00,000","₹40 + GST"]
]}
/>

<Section id="P" title="Demand Draft / Pay Order"
rows={[
["Up to ₹5,000","₹25 + GST"],
["₹5,001–₹20,000","₹50 + GST"],
["₹20,001–₹1L","₹100 + GST"],
["₹1L–₹2L","₹125 + GST"],
["Above ₹2L","₹125 + ₹2 per thousand + GST"]
]}
/>

<Section id="Q" title="Cancellation of Pay Order"
rows={[
["Charges","₹50 + GST"]
]}
/>

<Section id="R" title="CC / OD Renewal Charges"
rows={[
["Existing facility","0.5% of CC amount + GST"]
]}
/>

<Section id="T" title="Loan Processing Charges"
rows={[
["General loans / CC","1% of loan amount"],
["Gold loan","0.50%"]
]}
/>

<Section id="A2" title="ATM Charges"
rows={[
["New ATM card","₹100 + GST"],
["Duplicate ATM card","₹300 + GST"],
["Annual maintenance","₹150/year + GST"],
["Other bank ATM after 3 free","₹25 + GST"],
["Non financial ATM","₹10 + GST"]
]}
/>

<Section id="A3" title="ECS / ACH / NACH Charges"
rows={[
["Return up to ₹1L","₹300 + GST"],
["Return ₹1L–10L","₹500 + GST"],
["Return above ₹10L","₹750 + GST"]
]}
/>

<Section id="A5" title="SMS Charges"
rows={[
["Per SMS per month","₹0.15 + GST"]
]}
/>

<Section id="A6" title="Safe Deposit Locker"
rows={[
["Extra visits beyond 6","₹100 + GST"],
["Break open locker","₹500 + vendor charges + GST"],
["Locker surrender","Actual vendor charges + GST"]
]}
/>

<Section id="A8" title="General Charges"
rows={[
["Old records enquiry","₹100 + GST"],
["Signature verification","₹50 + GST"],
["Balance certificate","₹50 + GST"],
["CIBIL Individual","₹100 + GST"],
["CIBIL Company","₹1000 + GST"]
]}
/>

<Section id="A9" title="Locker Deposit & Rent"
rows={[
["Locker rent","As per locker size + GST"]
]}
/>

</div>

);

}



function Section({id,title,rows}){

return(

<section className="fees-section" id={id}>

<div className="fees-card">

<div className="fees-card-header">

<span className="fees-badge">{id}</span>

{title}

</div>

{rows.map((r,i)=>(

<div key={i} className="fees-row">

<div>{r[0]}</div>

<div className="fees-price">{r[1]}</div>

</div>

))}

</div>

</section>

);

}